import { Component, OnInit } from '@angular/core';
import { transition, trigger, animate, style, keyframes } from '@angular/animations';
import{fade,slide,down}from'../../animation/animation'
import { LowerCasePipe } from '@angular/common';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css'],
  // animations:[fade,slide,down]
})
export class LandingPageComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

}
